import { Reducer } from 'redux';
import { LotsState } from 'models';
import { LotsActionTypes } from './action-types';

const initialState: LotsState = {
  lotsList: [],
  loading: false,
  error: false,
};

export const reducer: Reducer<LotsState> = (state = initialState, action) => {
  switch (action.type) {
    case LotsActionTypes.REQUEST_LOTS_START:
      return { ...state, loading: true, error: false };
    case LotsActionTypes.REQUEST_LOTS_SUCCESS:
      return { ...state, lotsList: action.payload, loading: false };
    case LotsActionTypes.REQUEST_LOTS_FAILED:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};
